import moment from 'moment'
import AuthMixin from '@/components/mixins/auth-mixin'
import ReportingSearchBar from './reporting-search-bar/reporting-search-bar-tmpl'
import TagSlider from '@/components/common/tag-slider/tag-slider-tmpl'
import CONST from '@/globals/constants'

export default {
  name: 'reporting',
  inject: [
    '$currentUser',
    '$utils',
    '$dataStore',
    '$api',
    '$apiError'
  ],
  components: {
    ReportingSearchBar,
    TagSlider
  },
  props: {
    dataProp: {
      type: String,
      default () { return '' }
    }
  },
  watch: {
    dataProp (val) {
      this.dataPropVal = val
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      CONST,
      title: 'aside-layout-structure-page',
      dataPropVal: this.dataProp,
      dateFilterOptions: [],
      selectedDateFilter: null,
      refreshTagSlider: { ref: null, refresh: false },
      reportOnLoadPage: null,
      report: {
        batchSelected: 0,
        batchHistory: [],
        itemsToShow: {
          activity: {
            accounting: [],
            media: [],
            monitoring: []
          }
        },
        totalPages: 1,
        paginationBar: [],
        reqFilter: { search: '' }
      },
      selectedTagsFromSlider: [],
      activity: {
        accounting: [],
        media: [],
        monitoring: []
      },
      mediaContentStyle: { height: '0px' },
      showNoSearchResults: false,
      showMediaSummary: true,

      maxPlayerPerRow: 6
    }
  },
  computed: {
    paginatorData () {
      // Calculate pagination data to be passed to the
      // Paginator component

      // Get current page and total pages
      const currentPage = this.report.batchSelected + 1;
      const totalPages = this.report.totalPages;

      // Get previous pages items count based on the
      // current page and max player per page count
      const previousPagesItemsCount = currentPage > 1
        ? (currentPage - 1) * this.maxPlayerPerRow
        : 0;

      // Get current page items from batch history excluding
      // empty columns
      const currentPageItems = this.report?.batchHistory[this.report?.batchSelected]?.monitoring?.filter((item) => !item.emptyColumn)
      const currentPageItemsCount = currentPageItems?.length ? currentPageItems.length : 0;

      // Get minimum and maximum items count for the current page
      const minItemsCount = currentPage > 1
        ? previousPagesItemsCount + 1
        : currentPageItemsCount > 0 ? 1 : 0;
      const maxItemsCount = currentPage > 1
        ? previousPagesItemsCount + currentPageItemsCount
        : currentPageItemsCount;

      // Get total items count
      const totalItemsCount = this.report.itemsToShow.activity.totalPlayers;

      return {
        currentPage,
        totalPages,
        minItemsCount,
        maxItemsCount,
        totalItemsCount,
      };
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('reporting-page-change', { action, payload: { data } })
      }
    },
    localizedMoment (date) {
      return moment(date).locale(this.$dataStore.getLanguage().code)
    },
    setDefaultData () {
      this.createDateFilterOptions()
      this.showMediaSummary = this.$currentUser.hasFeatureProofOfPlayBasic()
    },
    getMonitoringLogs (params) {
      if (!params) params = {}

      let reqParams = { max: this.maxPlayerPerRow, use_qsa: 1 }

      if (this.selectedTagsFromSlider.length) {
        reqParams.tags = JSON.stringify(this.selectedTagsFromSlider)
      }

      // Get search text value
      if (this.report.reqFilter.search !== '') {
        reqParams.search = this.report.reqFilter.search
      }

      // Selected date
      if (this.selectedDateFilter) {
        const dateFilter = this.localizedMoment(this.selectedDateFilter)
        reqParams.start = dateFilter.clone().utc().startOf('month').toISOString()
        reqParams.end = dateFilter.clone().utc().endOf('month').toISOString()
      }

      if (params.apiRequestParams) {
        reqParams = { ...reqParams, ...params.apiRequestParams }
      }

      if (params.targetBatchIndex) {
        const exclusiveStartSerialNumber = this.report.pageExclusiveStartSerialNumbers[params.targetBatchIndex + 1]
        reqParams.exclusiveStartSerialNumber = exclusiveStartSerialNumber
      }

      const getMonitoringRequest = () => {
        this.$utils.mainLoader(true)

        this.$api.get(`${CONFIG.API_BASE_URL}/report/player-activity`, { params: reqParams })
          .then(response => {
            const newResponseData = response.data
            const processNewResponseData = (newMonitoringBatch) => {
              const processNewbatch = () => {
                const report = this.$utils.clone(this.report)

                // Set total number of pages
                let numberOfPages = (newResponseData.totalPlayers) ? newResponseData.totalPlayers / this.maxPlayerPerRow : 1
                report.totalPages = Math.trunc((numberOfPages - Math.floor(numberOfPages)) !== 0 ? numberOfPages += 1 : numberOfPages)

                // Create Batch array based on the
                const targetBatchIndex = params.targetBatchIndex ? params.targetBatchIndex : 0
                const updatedBatchHistory = this.$utils.clone(report.batchHistory)

                if (!report.batchHistory.length) {
                  for (let i = 1; i <= numberOfPages; i++) {
                    updatedBatchHistory.push(null)
                  }
                }

                // Process new batch
                if (newMonitoringBatch.monitoring.length > 0) {
                  newMonitoringBatch = this.filterMonitoringData(newMonitoringBatch)

                  // Put new batch in history
                  updatedBatchHistory[targetBatchIndex] = newMonitoringBatch
                  report.batchHistory = updatedBatchHistory

                  // Update items to Show
                  report.itemsToShow.activity = newMonitoringBatch

                  // Exclusive serial numbers
                  report.pageExclusiveStartSerialNumbers = newResponseData.pageExclusiveStartSerialNumbers

                  this.report = report

                  if (!this.reportOnLoadPage) {
                    this.reportOnLoadPage = this.report
                  }
                }
              }

              if (params.refreshList) {
                this.handleResetReport()
                processNewbatch()
              } else {
                processNewbatch()
              }

              if (params.callback) {
                params.callback()
              } else {
                this.$utils.mainLoader(false)
              }
            }

            processNewResponseData(newResponseData)
          })
          .catch((error) => {
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { getMonitoringRequest() } })
          })
      }
      getMonitoringRequest()
    },
    filterMonitoringData (activitySrc) {
      const activity = this.$utils.clone(activitySrc)

      // Filter media
      activity.media.forEach((media, indx) => {
        if (!media._edit) activity.media[indx]._edit = {}

        // For Ajax iframes
        activity.media[indx]._edit.uid = media.resourceId
        activity.media[indx]._edit.iFrameStatus = 'default'
        activity.media[indx]._edit.fetchingIframeContent = false
        activity.media[indx]._edit.iframeContent = null
        activity.media[indx]._edit.preview = media.preview
      })

      const percentageFormat = (val) => {
        let res = val.toFixed(2)
        if (res >= 100) res = 100
        return res
      }

      // Filer monitoring/players
      for (const indx in activity.monitoring) {
        const item = activity.monitoring[indx]

        if (!item._edit) {
          item._edit = {
            averageUptime: item.averageUptime ? `${percentageFormat(item.averageUptime)}%` : '0%',
            averageOnlineTime: item.averageOnlineTime ? `${percentageFormat(item.averageOnlineTime)}%` : '0%',
            numberOfRestarts: item.numberOfRestarts ? item.numberOfRestarts : '0'
          }
        }
      }

      // Default empty column for UI
      if (activity.monitoring.length < 6) {
        const numEmptyColumn = 6 - activity.monitoring.length

        for (let i = 1; i <= numEmptyColumn; i++) {
          activity.monitoring.push({ emptyColumn: true })
        }
      }

      // Filter media
      activity.mediaInPlayer = []
      if ((activity.media && activity.accounting) && (activity.media.length && activity.accounting.length)) {
        activity.mediaInPlayer = this.$utils.clone(activity.media).map(media => {
          media.accounting = this.$utils.clone(activity.accounting).filter((m) => { return m.resourceId === media.resourceId })

          // Copy the original monitoring list and fill up playersPlayed to maintain the column order and will align the data from player column
          media.monitoring = []
          activity.monitoring.forEach((item) => {
            const findFromAccounintg = media.accounting.find((a) => { return a.serialNumber === item.serialNumber })
            const newItem = this.$utils.clone(item) // Create a new item to avoid inconsistent value inside the loop

            if (findFromAccounintg) newItem.playedInPlayer = findFromAccounintg

            media.monitoring.push(newItem)
          })

          return media
        })
      }

      return activity
    },
    handleResetReport () {
      this.report = {
        batchSelected: 0,
        batchHistory: [],
        itemsToShow: {
          activity: {
            accounting: [],
            media: [],
            monitoring: []
          }
        },
        totalPages: 1,
        reqFilter: { search: '' }
      }
    },
    createDateFilterOptions () {
      const dateOptions = []

      for (let i = 0; i <= 2; i++) {
        const getPrevMonth = this.localizedMoment().subtract(i, 'months')
        const dateDetails = {
          origDate: getPrevMonth.clone(),
          monthNum: getPrevMonth.clone().format('M'),
          monthLabel: getPrevMonth.clone().format('MMM'),
          year: getPrevMonth.clone().format('YYYY'),
          value: getPrevMonth.clone().set({ hour: 0, minute: 0, second: 0 }).format('YYYY-MM-DD[T]HH:mm:ss'),
          isCurrentMonth: getPrevMonth.clone().format('M') === this.localizedMoment().format('M')
        }
        dateOptions.unshift(dateDetails)
      }

      this.dateFilterOptions = dateOptions
    },
    handleDateFilterClick ($event, date, indx) {
      if (date.value) {
        this.selectedDateFilter = date.value
        this.getMonitoringLogs({ refreshList: true })
      }
    },
    handleTagSliderChange ($event) {
      switch ($event.action) {
        case CONST.EMIT_EVENT_NEW_SELECTED_TAGS_FROM_SLIDER: {
          this.selectedTagsFromSlider = $event.payload.data
          this.getMonitoringLogs({ refreshList: true })
          break
        }
        default: {
          this.selectedTagsFromSlider = []
          this.getMonitoringLogs({ refreshList: true })
        }
      }
    },
    calculateMediaListHeight () {
      const contentHeight = parseInt($('.reporting-content-row').height())
      const playersReportEl = $('#playersReport').length ? $('#playersReport').height() : 250
      let offsetVal = 65
      if (this.$utils.is1280View()) offsetVal = 46 // small screen
      const mediaContentHeight = (contentHeight - playersReportEl) - offsetVal

      this.mediaContentStyle = { height: `${mediaContentHeight}px` }
    },
    updatePaginationPage (batchIndex) {
      const report = this.$utils.clone(this.report)
      report.batchSelected = batchIndex

      const itemsToShow = report.batchHistory[batchIndex]

      if (itemsToShow) {
        report.itemsToShow.activity = report.batchHistory[batchIndex]
      } else {
        this.getMonitoringLogs({
          targetBatchIndex: batchIndex
        })
      }

      this.report = report
    },
    handlePageSelect (pageNumber) {
      // Calculate the batch index based on the page number
      const batchIndex = pageNumber > 0 ? pageNumber - 1 : 0
      this.updatePaginationPage(batchIndex)
    },
    handleDownloadReport () {
      const params = {
        url: `${CONFIG.API_BASE_URL}/report/player-activity`,
        label: `report-${this.localizedMoment().format('YYYY-DD-MM')}.csv`,
        dataType: 'text/csv',
        reqParams: { format: 'csv' },
        showLoader: true
      }

      // Selected date
      if (this.selectedDateFilter) {
        const dateFilter = this.localizedMoment(this.selectedDateFilter)
        params.reqParams.start = dateFilter.clone().utc().startOf('month').toISOString()
        params.reqParams.end = dateFilter.clone().utc().endOf('month').toISOString()
        params.label = `report-${dateFilter.clone().format('YYYY-DD-MM')}.csv`
      }

      this.$utils.downloadDocument(params)
    },
    handleReportingSearchBarChange (event) {
      const processNewbatch = (newMonitoringBatch) => {
        this.handleResetReport()
        const report = this.$utils.clone(this.report)

        // Process new batch
        if (newMonitoringBatch.monitoring.length > 0) {
          newMonitoringBatch = this.filterMonitoringData(newMonitoringBatch)

          // Put new batch in history
          report.batchHistory.push(newMonitoringBatch)

          // Update items to Show
          report.itemsToShow.activity = newMonitoringBatch

          report.reqFilter = event.payload.data.reqSearchFilter

          this.report = report
        }
      }

      if (event.action === 'NEW_PLAYER_SEARCH_RESULTS') {
        const newSearchResults = event.payload.data.searchResults
        processNewbatch(newSearchResults.fullDetailsList)

        // After backend request final result
        if (event.payload.data.afterAPIRequest) {
          if (!this.report.itemsToShow.activity.monitoring.length) {
            this.showNoSearchResults = true
          } else {
            this.showNoSearchResults = false
          }
        } else if (!event.payload.data.afterAPIRequest && this.report.itemsToShow.activity.monitoring.length) {
          this.showNoSearchResults = false
        }
      }

      if (event.action === 'RESET_TO_ORIGINAL_LISTS') {
        this.report = this.reportOnLoadPage
      }
    }
  },
  mounted () {
    this.isAuthenticated({
      callback: () => {
        this.setDefaultData()
      }
    })

    $(window).on('resize', () => {
      this.$utils.updatePageComponentStyle({ name: 'reportingPage' })
      this.$nextTick(_ => { this.calculateMediaListHeight() })
    })
  }
}
